import {
  Backdrop,
  Button,
  Card,
  CardContent,
  Snackbar,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  TextField,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormGroup
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import AddCommentIcon from '@material-ui/icons/AddComment';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { Scrollbars } from 'react-custom-scrollbars';
import Moment from 'moment';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from 'clsx';
import Yardimci from './Helper';
const useStyles = makeStyles(theme => ({
  root: {},
  dividerYorum: {
    backgroundColor: '#1D3343'
  },
  cardsMax: {
    maxHeight: 550,
    minHeight: 550
  },
  fieldsComboYorum: {
    margin: theme.spacing(0),
    display: 'flex'
  },
  content: {
    minHeight: 160
  },
  submitButtonComment: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function Yorum({ className, ReceiptNo, setOpenSnackbar, setResponseType, setResponseDsc, readonly, tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  const [LoadingControl, setLoadingControl] = useState(false);
  const [YorumDetay, setYorumDetay] = React.useState([]);
  const [ContextDetail, setContextDetail] = React.useState([]);
  const YorumData = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const [Kullanici, setKullanici] = useState([]);
  const [KullaniciId, setKullaniciId] = useState(0);
  const [Yorum, setYorum] = useState('');
  const [Header, setHeader] = useState('');
  const [Context, setContext] = useState('');
  const [IsCheckedType,setIsCheckedType] = useState('0');
  const handleChangeHeader = e => {
    setHeader(e.target.value);
  };
  const handleChangeType = e => {
    setIsCheckedType(e.target.value);
  };
  const handleChangeContext = e => {
    setContext(e.target.value);
  };
  const GetYorumKullanici = () => {
    axios
      .get(
        `/GetSiriusCommentUsers/${YorumData[0]?.ReceiptNo}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`
      )
      .then(response => {
        if (response.data.length > 0) {
          setKullanici(response.data);
        }
      })
      .catch(error => { });
  };
  useEffect(() => {
    GetYorumKullanici();
    // eslint-disable-next-line
  }, [
    YorumData[0]?.ReceiptNo,
    SessionUser.ServiceShopId,
    SessionUser.TechnicianId
  ]);
  const handleChangeKullanici = e => {
    setKullaniciId(e.target.value);
  };
  const handleChangeYorum = e => {
    setYorum(e.target.value);
  };
  const handleYorumYap = () => {
    if (Yorum.length === 0) {
      setResponseType('error');
      setResponseDsc(t('yorum_yaziniz'));
      setOpenSnackbar(true);
      return;
    }

    const data1 = {
      ServiceShopId: parseInt(YorumData[0].ServiceShopId) || 0,
      WorkOrderId: parseInt(YorumData[0].ReceiptNo) || 1,
      AnswerUser: parseInt(KullaniciId) || 0,
      Comment: Yorum || '',
      QuestionUser: parseInt(SessionUser.OrganizationUserId) || 1,
      Id: 1,
      Control: 3
    };

    const config1 = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoadingControl(true);
    //setOpenSnackbar, setResponseType, setResponseDsc
    axios
      .post('/SetSiriusWorkOrderChat', data1, config1)
      .then(response => {
        setLoadingControl(false);
        const ResponseData1 = response.data;
        if (parseInt(ResponseData1.ErrorCode) !== 0) {
          setResponseType('error');
          setResponseDsc(ResponseData1.ErrorDescription);
        } else {
          setResponseType('success');
          setResponseDsc(t('lblYourCommentHasBeenSent'));
          GetYorum();
        }
        setOpenSnackbar(true);
      })
      .catch(error => {
        setLoadingControl(false);
        setResponseType('error');
        setResponseDsc(t('Error') + error.message);
        setOpenSnackbar(true);
      });
  };
  const handleContextSend = () => {
    if (Context.length === 0) {
      setResponseType('error');
      setResponseDsc(t('yorum_yaziniz'));
      setOpenSnackbar(true);
      return;
    }
    if (IsCheckedType === '0') {
      setResponseType('error');
      setResponseDsc(t('choose_type'));
      setOpenSnackbar(true);
      return;
    }
    const data1 = {
      ServiceShopId: parseInt(YorumData[0].ServiceShopId) || 0,
      WorkOrderId: parseInt(YorumData[0].ReceiptNo) || 1,
      AnswerUser: parseInt(KullaniciId) || 0,
      Context: Context || '',
      QuestionUser: parseInt(SessionUser.TechnicianId) || 1,
      Id: 0,
      QuestionType: IsCheckedType|| 0,
      Header:Header|| ''
    };
    const config1 = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoadingControl(true);
    //setOpenSnackbar, setResponseType, setResponseDsc
    axios
      .post('/SetSiriusTechnicalKnowledgeBaseWO', data1, config1)
      .then(response => {
        setLoadingControl(false);
        const ResponseData1 = response.data;
        const ResponseData2 = response.status;
        console.log(ResponseData1);
        if (parseInt(ResponseData2) !== 200) {
          setResponseType('error');
          setResponseDsc(ResponseData1.ErrorDescription);
        } else {
          setResponseType('success');
          setResponseDsc(t('lblYourCommentHasBeenSent'));
          GetContext();
        }
        setOpenSnackbar(true);
      })
      .catch(error => {
        setLoadingControl(false);
        setResponseType('error');
        setResponseDsc(t('Error') + error.message);
        setOpenSnackbar(true);
      });
  };
  const setYorumSilEvet = Id => {
    const data = [
      {
        AppNr: YorumData[0].BASVURU_NO,
        ServiceShopId: YorumData[0].BIRIM_KODU,
        CommentRequested: 0,
        UserId: YorumData[0].TEKNISYEN_KODU,
        Comment: '',
        Operation: 0,
        CommentId: Id,
        Decision: 0
      }
    ];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoadingControl(true);
    axios
      .post('/SetArtemisComment', data, config)
      .then(response => {
        setLoadingControl(false);
        const ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setResponseType('error');
          setResponseDsc(ResponseData.ErrorDescription);
        } else {
          setResponseType('success');
          setResponseDsc(ResponseData.ErrorDescription);
          GetYorum();
        }
        setOpenSnackbar(true);
      })
      .catch(error => {
        setLoadingControl(false);
        setResponseType('error');
        setResponseDsc(t('Error') + error.message);
        setOpenSnackbar(true);
      });
  };

  const GetYorum = () => {
    setLoadingControl(true);
    axios
      .get(`/GetSiriusChatWorkOrderDetail/${ReceiptNo}`)
      .then(response => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setYorumDetay([]);
        } else {
          setYorumDetay(Deger);
        }
        setLoadingControl(false);
      })
      .catch(error => {
        setYorumDetay([]);
        setLoadingControl(false);
      });
  };
  const GetContext = () => {
    setLoadingControl(true);
    axios
      .get(`/GetSiriusTechnicalKnowledgeBaseWO/${ReceiptNo}`)
      .then(response => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setContextDetail([]);
        } else {
          setContextDetail(Deger);
        }
        setLoadingControl(false);
      })
      .catch(error => {
        setContextDetail([]);
        setLoadingControl(false);
      });
  };
  useEffect(() => {
    GetYorum();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    GetContext();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const fetchCategories = async () => {
      // let cat = await getCategories();
      // setKararData(cat);
    };
    fetchCategories();
  }, []);

  return (
    <Card className={clsx(classes.root, className)}>
      <ExpansionPanel defaultExpanded = {true}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <CardHeader title={t('Fis_Yorum')} />
          <Divider />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <CardContent>
              <Typography variant="h6" component="h2" gutterBottom>
                <FormControl variant="outlined" className={classes.fieldsComboYorum}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('Kullanici')}
                    onChange={handleChangeKullanici}
                    value={KullaniciId}
                    variant="outlined"
                  >
                    {Kullanici.map(p => {
                      return (
                        <MenuItem key={p.Id} value={p.Id}>
                          {p.UserName}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </FormControl>
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                <TextField
                  label={t('Yorum_input')}
                  name="Yorum"
                  multiline
                  rows={4}
                  fullWidth
                  value={Yorum}
                  onChange={handleChangeYorum}
                  variant="outlined"
                  disabled={readonly}
                />
              </Typography>
              <Grid item xs={12} sm={12} lg={12} style={{ textAlign: 'right' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleYorumYap}
                  disabled={readonly}
                  endIcon={<AddCommentIcon>Gonder</AddCommentIcon>}
                >
                  {t('Yorum_Yap')}
                </Button>
              </Grid>
              </CardContent>
            </Grid>
          
          <Divider />
          
            <Grid item xs={12} sm={12} lg={12}>
              <CardContent className={classes.content}>
            <Scrollbars style={{ width: '100%', height: 200, align: 'left' }}>
              <List className={classes.root}>
                {YorumDetay.map((log, index) => (
                  <div key={index}>
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary=""
                        secondary={
                          <>
                            <Typography
                              component="span"
                              variant="body1"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              <b>{t('Kullanici')}:</b> {log.QuestionUser}
                              <br />
                              <b>{t('Tarih')}:</b> {log.QuestionDate === undefined ? '' : Moment(log.QuestionDate).format('DD/MM/YYYY HH:mm')}
                              <br />
                              <b>{t('Mesaj')}:</b> {log.Question}
                              <br />
                              <b>{t('Yanitlayan')}:</b> {log.AnswerUser}
                              <br />
                              <b>{t('Yanit_Tarih')}:</b> {log.AnswerDate === undefined ? '' : Moment(log.AnswerDate).format('DD/MM/YYYY HH:mm')}
                              <br />
                              <b>{t('Yanit')}:</b> {log.Answer}
                            </Typography>
                          </>
                        }
                      />
                      {/* <ListItemSecondaryAction>
                      <RemoveCircleIcon onClick={() => setYorumSil(log.Id)} style={{ color: "red" }} />
                    </ListItemSecondaryAction> */}
                    </ListItem>
                    <Divider className={classes.dividerYorum} />
                  </div>
                ))}
              </List>
            </Scrollbars>

              </CardContent>
            </Grid>
          </Grid>
          
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <Yardimci ReceiptNo={ReceiptNo} readonly={readonly} />
    </Card>
  );
}

Yorum.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({
  tasks: state.tasks1
}))(Yorum);
